import {
  CreateTaskInput,
  CreateTaskMutationVariables,
  DeleteTaskInput,
  DeleteTaskMutationVariables,
  UpdateTaskInput,
  UpdateTaskMutationVariables,
} from '@/API';
import {
  CreateTaskMutation,
  DeleteTaskMutation,
  UpdateTaskMutation,
  createTaskWithConnection as createTaskMutation,
  updateTaskWithConnection as updateTaskMutation,
  deleteTaskWithConnection as deleteTaskMutation,
} from '@/appsync/graphql/task';
import { graphqlQuery } from '@/appsync/service/GraphqlUtils';

export const createTask = async (task: CreateTaskInput): Promise<void> => {
  const variables: CreateTaskMutationVariables = {
    input: task,
  };

  await graphqlQuery<CreateTaskMutation, CreateTaskMutationVariables>(
    createTaskMutation,
    variables
  );
};

export const updateTask = async (task: UpdateTaskInput): Promise<void> => {
  const variables: UpdateTaskMutationVariables = {
    input: task,
  };

  await graphqlQuery<UpdateTaskMutation, UpdateTaskMutationVariables>(
    updateTaskMutation,
    variables
  );
};

export const deleteTask = async (
  deleteTaskInput: DeleteTaskInput
): Promise<DeleteTaskMutation | null> => {
  const variables: DeleteTaskMutationVariables = {
    input: deleteTaskInput,
  };

  const result = await graphqlQuery<
    DeleteTaskMutation,
    DeleteTaskMutationVariables
  >(deleteTaskMutation, variables);

  return result;
};
